import { render, staticRenderFns } from "./ShowClueArchives.vue?vue&type=template&id=04d83e48&"
import script from "./ShowClueArchives.vue?vue&type=script&lang=js&"
export * from "./ShowClueArchives.vue?vue&type=script&lang=js&"
import style0 from "./ShowClueArchives.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports